import React from 'react';


import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Menu from './MenuComponent';
import styled from 'styled-components';
import EventListener from 'react-event-listener';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MenuBookIcon from '@material-ui/icons/MenuBook';
// import BoltIcon from '@material-ui/icons/Bolt'; 


// import ElectricBoltIcon from 'material-ui/icons/ElectricBolt';
import { withRouter } from 'react-router';
import DashboardIcon from '@material-ui/icons/Dashboard';
import TimelineIcon from '@material-ui/icons/Timeline';
import EventNoteIcon from '@material-ui/icons/EventNote';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import SubjectIcon from '@material-ui/icons/Subject';
import PLibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
// const Button = styled.button`
//     background: red;
//     border-radius: 8px;
//     color: white;
// `;

const MDiv = styled.div`
    list-style-type: none;
   
`;


const ElectricBoltIcon = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="30"
      viewBox="0 0 28 28"
      width="40"
      fill="#fff" // 色を変更する場合はここを調整
      {...props} // 追加の props を受け付けるようにする
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M11 21h-1l1-7H7l6-11h1l-1 7h4z" />
    </svg>
  );

const styles = ((theme) => ({
    root: {
        // flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
        // display: 'flex',

        color: "#FFF",
        textAlign: "center",
        paddingTop: 10,
        paddingLeft: 10,
        // height: 224,
    },
    active: {
        // flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
        // display: 'flex',
        paddingTop: 10,
        color: "#FFF",
        textAlign: "center",
        paddingLeft: 10,
        backgroundColor: "#b0c4de"
        // height: 224,
    },
    gutters: {
        textAlign: "center"
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        width: 60,
        color: "#FFF",
        paddingLeft: 3
    },

}))


class NavMenu extends React.Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.link = this.link.bind(this);


        //this.state = {
        //  isOpen: false
        //};
        this.state = {
            dropdownOpenBuilding: false,
            dropdownOpenPatrol: false,
            height: window.innerHeight,
            showFlag: 0
        };
    }
    toggle() {
        //this.setState({
        //  isOpen: !this.state.isOpen
        //});
        //this.setState(prevState => ({
        //    dropdownOpen: !prevState.dropdownOpen
        //}));
        //this.setState({
        //    dropdownOpenBuilding: !this.state.dropdownOpenBuilding,
        //    dropdownOpenPatrol: !this.state.dropdownOpenPatrol,
        //});
    }
    handleResize = () => {
        this.setState({ height: window.innerHeight });
    };

    link = (link) => {

        this.props.history.push(link)
    }

    render() {
        return (

            <div id="aside" style={{ position: "relative" }}>




                <MenuList >
                    <MenuItem className={this.props.location.pathname === "/dashboard" ? this.props.classes.active : this.props.classes.root} onClick={() => this.link('/dashboard')}>
                        <div>
                            <div><DashboardIcon style={{ fontSize: 28 }} />
                            </div>
                            <div style={{ fontSize: "8px", marginTop: "5px", marginLeft: "0px", color: "#FFFFFF" }}>ボ ー ド</div>
                        </div>
                    </MenuItem >

                    <MenuItem className={this.props.location.pathname === "/contractcheck" ? this.props.classes.active : this.props.classes.root} onClick={() => this.link('/contractcheck')}>
                        <div>
                            <div><MenuBookIcon style={{ fontSize: 28 }} />
                            </div>
                            <div style={{ fontSize: "8px", marginTop: "5px", marginLeft: "0px", color: "#FFFFFF" }}>契約管理</div>
                        </div>
                    </MenuItem >

                    <MenuItem className={this.props.classes.root}>
                        <a href='https://officenext.homestation.jp/PowerOnManagement/' target='_blank' style={{textDecoration:"none"}}> 
                            <div><ElectricBoltIcon style={{ fontSize: 30 }} />
                            </div>
                            <div style={{ fontSize: "8px", marginTop: "5px", marginLeft: "0px", color: "#FFFFFF" }}>通電確認</div>
                        </a>
                    </MenuItem >

                    <MenuItem className={this.props.location.pathname === "/Accounting" ? this.props.classes.active : this.props.classes.root} onClick={() => this.link('/Accounting')}>
                        <div>
                            <div><AccountBalanceWalletIcon style={{ fontSize: 28 }} /></div>
                            <div style={{ fontSize: "8px", marginTop: "5px", marginLeft: "0px", color: "#FFFFFF" }}>　入金　</div>
                        </div>
                    </MenuItem>
                    <MenuItem className={this.props.location.pathname === "/Kyousai" ? this.props.classes.active : this.props.classes.root} onClick={() => this.link('/Kyousai')}>
                        <div>
                            <div><SubjectIcon style={{ fontSize: 28 }} /></div>
                            <div style={{ fontSize: "8px", marginTop: "5px", marginLeft: "0px", color: "#FFFFFF" }}>　共済　</div>
                        </div>
                    </MenuItem>
                    <MenuItem className={this.props.location.pathname === "/ContractConfirm" ? this.props.classes.active : this.props.classes.root} onClick={() => this.link('/ContractConfirm')}>
                        <div>
                            <div><PLibraryAddCheckIcon style={{ fontSize: 28 }} /></div>
                            <div style={{ fontSize: "8px", marginTop: "5px", marginLeft: "0px", color: "#FFFFFF" }}>契約確認</div>
                        </div>
                    </MenuItem>
                    {/* <MenuItem className={this.props.location.pathname === "/MailTemplate" ? this.props.classes.active : this.props.classes.root} onClick={() => this.link('/MailTemplate')}>
                        <div>
                            <div><DynamicFeedIcon style={{ fontSize: 28 }} /></div>
                            <div style={{ fontSize: "8px", marginTop: "5px", marginLeft: "0px", color: "#FFFFFF" }}>テンプレ</div>
                        </div>
                    </MenuItem>

                    <MenuItem className={this.props.classes.root} >
                        <div>
                            <div><TimelineIcon style={{ fontSize: 28 }} /></div>
                            <div style={{ fontSize: "8px", marginTop: "5px", marginLeft: "0px", color: "#FFFFFF" }}>シナリオ</div>
                        </div>
                    </MenuItem> */}





                </MenuList>

































            </div >
        );
    }
}
export default withRouter(withStyles(styles)(NavMenu));